export * from './useBffGetQuery.types';
export { default as useBffGetQuery } from './useBffGetQuery';
